module.exports = __webpack_public_path__ + "img/arrow_back.ca65fc66.svg";